import { useTranslation } from 'react-i18next';
import { ErrorBoundary } from '../ErrorBoundary';

export function PublicErrorBoundary({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();

  return (
    <ErrorBoundary
      fallback={
        <div className="min-h-screen flex items-center justify-center p-4">
          <div className="max-w-md w-full space-y-4 text-center">
            <h1 className="text-2xl font-bold text-foreground">{t('error.title')}</h1>
            <p className="text-muted-foreground">{t('error.description')}</p>
            <button
              onClick={() => window.location.reload()}
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90 px-4 py-2 rounded-md"
            >
              {t('error.retry')}
            </button>
          </div>
        </div>
      }
    >
      {children}
    </ErrorBoundary>
  );
}
